<template>
  <AppModalEdit
    :value="true"
    :confirm-on-click-cancel="true"
    :isExecButtonDisabled="checkLocationValid()"
    @clickExec="onClickSave"
    @cancel="cancel"
    min-height="0px"
    exec-button-text="保存"
    cancel-button-text="保存せず終了"
    persistent
  >
    <AppOverlay v-model="loading" v-if="!isFetchSimulationPoiLocations">
      <AppLoadingSpinner text="地点読み込み中..." class="loading-card" />
    </AppOverlay>
    <AppOverlay v-model="isFetchSimulationPoiLocations">
      <AppLoadingSpinner text="地点グループ保存中..." class="ma-3" />
    </AppOverlay>
    <div class="wrap">
      <div
        ref="settingArea"
        v-bind:style="{
          height: `450px`,
          minHeight: `30px`,
        }"
        class="settingArea"
      >
        <EditLocationGroup
          :poiSearchForm.sync="poiSearchForm"
          :mode="mode"
          :locationCount="pointList.length"
          :simulationValid="checkSimulationValid()"
          @change="fetchPoiLocations"
        />
      </div>
    </div>
    <v-dialog v-model="isShowModal" persistent max-width="800">
      <v-card>
        <v-card-title>
          <p class="title">作成するグループの名称を入力して下さい</p>
        </v-card-title>
        <v-card-text>
          <v-layout>
            <v-flex xs1>
              <AppForm label="グループ名" />
            </v-flex>
            <v-flex xs9 ml-5 class="target-group-name">
              <v-text-field v-model="groupName" hide-details />
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <AppButtonCancel @click="isShowModal = false">
            キャンセル
          </AppButtonCancel>
          <AppButtonOk @click="save" color="primary">
            保存
          </AppButtonOk>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </AppModalEdit>
</template>

<script>
import EditLocationGroup from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/LocationGroup/EditLocationGroup'
import { POISearchFormModel } from '@/models/POI/POISearchForm'
import { POICategoryRepository } from '@/models/POICategoryRepository'

export default {
  name: 'SimulationContentDeliverySidebarPoiGroupSettingModal',
  components: {
    EditLocationGroup,
  },
  props: {
    mode: {
      type: Object,
      default: () => {
        return {
          type: 'create',
          text: '登録',
        }
      },
    },
    isFetchSimulationPoiLocations: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      pointList: [],
      poiSearchForm: null,
      isShowModal: false,
      loading: false,
      groupName: null,
    }
  },
  created() {
    this.map = null
    this.poiSearchForm = POISearchFormModel.assign()
  },
  methods: {
    onClickSave() {
      if (this.mode.type === 'create') {
        this.setDefaultLocationGroupName()
        this.isShowModal = true
      } else this.save()
    },
    async save() {
      if (this.mode.type === 'create') {
        if (this.groupName === '' || this.groupName === null) {
          await this.$confirm('エラー', {
            okText: '閉じる',
            onlyOk: true,
            body: 'グループ名を入力してください',
          })
          return
        } else {
          this.poiSearchForm.name = this.groupName
        }
      }
      this.isShowModal = false
      this.$emit('save', this.poiSearchForm)
    },
    cancel() {
      this.$emit('cancel')
    },
    async fetchPoiLocations() {
      this.loading = true
      this.pointList = await this.poiSearchForm.searchPoiLocationList()
      this.$nextTick(() => {
        this.loading = false
      })
    },
    checkSimulationValid() {
      return this.pointList.length > 20000
    },
    checkLocationValid() {
      return this.checkSimulationValid() || this.pointList.length === 0
    },
    async setDefaultLocationGroupName() {
      const poiCategoryList = await POICategoryRepository.getCategory()
      const category = poiCategoryList.filter(
        category => category.id === this.poiSearchForm.categoryId,
      )
      if (category.length === 0) {
        return
      }
      const categoryName = category[0].name
      const areaNames = []
      if (
        this.poiSearchForm.administrativeDistrictType === 'prefecture' &&
        this.poiSearchForm.area.prefectureAreaObj.prefectureIdAndNames.length >
          0
      )
        this.poiSearchForm.area.prefectureAreaObj.prefectureIdAndNames.forEach(
          prefecture => areaNames.push(prefecture.name),
        )
      if (
        this.poiSearchForm.administrativeDistrictType === 'city' &&
        this.poiSearchForm.area.cityAreaObj.prefectures.length > 0
      ) {
        this.poiSearchForm.area.cityAreaObj.prefectures.forEach(prefecture =>
          prefecture.cityIdAndNames.forEach(city => areaNames.push(city.name)),
        )
      }
      if (areaNames.length === 0) {
        this.groupName = categoryName + '_全国'
        return
      }
      this.groupName = categoryName + '_' + areaNames.join('・')
    },
  },
}
</script>

<style scoped>
.wrap {
  height: 50vh;
  display: flex;
  flex-direction: column;
  align-items: stretch;
}
.settingArea {
  height: 50vh;
  overflow: scroll;
}
.target-group-name {
  margin-top: -20px;
}
.loading-card {
  flex: 0.3 !important;
}
</style>
